import DOMPurify from "dompurify";

export function useDomPurifier(value) {
    const purifiedValue = new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;
    return DOMPurify.sanitize(purifiedValue);
}